var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 43035"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.6664 19.6666V11.2666M13.6664 11.2666L17.2664 14.8666M13.6664 11.2666L10.0664 14.8666",
    stroke: "#008556",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.4665 7.6665H13.6665H8.86646",
    stroke: "#008556",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M1.6665 13.6665C1.6665 8.00964 1.6665 5.18122 3.42387 3.42387C5.18122 1.6665 8.00964 1.6665 13.6665 1.6665C19.3233 1.6665 22.1518 1.6665 23.9091 3.42387C25.6665 5.18122 25.6665 8.00964 25.6665 13.6665C25.6665 19.3233 25.6665 22.1518 23.9091 23.9091C22.1518 25.6665 19.3233 25.6665 13.6665 25.6665C8.00964 25.6665 5.18122 25.6665 3.42387 23.9091C1.6665 22.1518 1.6665 19.3233 1.6665 13.6665Z",
    stroke: "#008556",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadMedia);
export default __webpack_public_path__ + "static/media/upload-media.e16f4694078e7747eb86249a3118cac4.svg";
export { ForwardRef as ReactComponent };